"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNotificationHub = exports.COLOR_TRANSLATE = void 0;
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var NotificationCloseButton_1 = __importDefault(require("./components/NotificationCloseButton"));
var NotificationBody_1 = __importDefault(require("./components/NotificationBody"));
exports.COLOR_TRANSLATE = {
    primary: "info",
    danger: "error",
    warning: "warn",
    success: "success"
};
var WrappedToastContainer = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(react_toastify_1.ToastContainer, __assign({}, props))));
};
exports.StyledNotificationHub = styled_components_1.default(WrappedToastContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .Toastify__toast {\n    ", ";\n    ", ";\n    ", ";\n    ", "\n    border-radius: ", ";\n    font-family: ", ";\n\n    &.Toastify__toast--error,\n    &.Toastify__toast--warning,\n    &.Toastify__toast--info,\n    &.Toastify__toast--success {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &.Toastify__toast--error {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--warning {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--info {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--success {\n      border-left: 0.5rem solid ", ";\n    }\n\n    .Toastify__subtitle {\n      color: ", ";\n      font-size: 12px;\n    }\n  }\n"], ["\n  .Toastify__toast {\n    ", ";\n    ", ";\n    ", ";\n    ", "\n    border-radius: ", ";\n    font-family: ", ";\n\n    &.Toastify__toast--error,\n    &.Toastify__toast--warning,\n    &.Toastify__toast--info,\n    &.Toastify__toast--success {\n      background-color: ", ";\n      color: ", ";\n    }\n\n    &.Toastify__toast--error {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--warning {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--info {\n      border-left: 0.5rem solid ", ";\n    }\n\n    &.Toastify__toast--success {\n      border-left: 0.5rem solid ", ";\n    }\n\n    .Toastify__subtitle {\n      color: ", ";\n      font-size: 12px;\n    }\n  }\n"])), style_utils_1.setPadding("y", 3), style_utils_1.setPadding("left", 3), style_utils_1.setPadding("right", 4), function (props) { return style_utils_1.setBoxShadow(style_utils_1.shadowSelector(props, 8)); }, style_utils_1.getBorderRadius("md"), style_utils_1.getFont("sansSerif"), style_utils_1.getColor("gray", 0), style_utils_1.getColor("gray", 900), style_utils_1.getColor("danger", 500), style_utils_1.getColor("warning", 500), style_utils_1.getColor("primary", 500), style_utils_1.getColor("success", 500), style_utils_1.getColor("gray", 600));
var NotificationHub = (function (_super) {
    __extends(NotificationHub, _super);
    function NotificationHub() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationHub.prototype.render = function () {
        return (react_1.default.createElement(exports.StyledNotificationHub, __assign({}, this.props, { closeButton: react_1.default.createElement(NotificationCloseButton_1.default, null), autoClose: 10000 })));
    };
    NotificationHub.defaultProps = {
        hideProgressBar: true
    };
    NotificationHub.send = function (color, content, options) {
        var _a = options || {}, subtitle = _a.subtitle, title = _a.title, icon = _a.icon, rest = __rest(_a, ["subtitle", "title", "icon"]);
        return react_toastify_1.toast[exports.COLOR_TRANSLATE[color]](react_1.default.createElement(NotificationBody_1.default, { color: color, subtitle: subtitle, title: title, icon: icon }, content), rest);
    };
    NotificationHub.dismiss = function (notificationId) {
        return react_toastify_1.toast.dismiss(notificationId);
    };
    return NotificationHub;
}(react_1.Component));
exports.default = NotificationHub;
var templateObject_1;
//# sourceMappingURL=index.js.map